import api from "@/lib/api";
import { toast } from "sonner";

/**
 * Trigger browser download for backend-generated Excel file.
 * @param {string} url - relative API path
 * @param {string} fallbackName
 */
export async function downloadFile(url, fallbackName = "download.xlsx") {
  try {
    const res = await api.get(url, { responseType: "blob" });
    let filename = fallbackName;
    const cd = res.headers["content-disposition"] || res.headers["Content-Disposition"];
    if (cd) {
      const m = cd.match(/filename="([^"]+)"/);
      if (m) filename = m[1];
    }
    const blob = new Blob([res.data], { type: res.headers["content-type"] });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
    toast.success("File berhasil diunduh");
  } catch (err) {
    toast.error("Gagal mengunduh file");
    throw err;
  }
}
